import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { api } from "../lib/api";
import { Card, Empty } from "./UI";
import { FileText, ExternalLink } from "lucide-react";

export function ClientFormsPanel({ client, category = "", match = "", title = "", emptyHide = false }) {
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api.get(`/clinical-forms?client_id=${client.id}`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [client.id]);
  if (!rows) return null;
  const rx = match ? new RegExp(match, "i") : null;
  const list = rows.filter((f) => (!category || f.category === category) && (!rx || rx.test(f.template_name || "")));
  if (emptyHide && list.length === 0) return null;
  const heading = title || (category ? `${category} (Clinical Forms)` : "Forms & Documents Filed");
  const openLibrary = () => navigate(`/clinical-forms?client=${client.id}`);
  const openForm = (f) => navigate(`/clinical-forms?client=${client.id}&form=${f.id}`);

  return (
    <Card className="mb-4 p-5" data-testid={`client-forms-panel${category ? `-${category.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : ""}`}>
      <div className="mb-3 flex items-center gap-2">
        <FileText size={15} className="text-[#7B6157]" />
        <h3 className="font-heading text-sm font-bold text-[#3E2723]">{heading}</h3>
        <span className="rounded-full bg-[#F5F2EB] px-2 py-0.5 text-[10px] font-bold text-[#6D4C41]">{list.length}</span>
        <button onClick={openLibrary} className="ml-auto flex items-center gap-1 text-xs font-semibold text-[#7B6157] hover:underline" data-testid="client-forms-open-library">
          Open in Forms Library <ExternalLink size={11} />
        </button>
      </div>
      {list.length === 0 ? (
        <Empty text={`No ${category ? category.toLowerCase() + " " : ""}forms filed for this client yet`} />
      ) : (
        <div className="space-y-1.5">
          {list.map((f) => (
            <button key={f.id} data-testid={`client-form-row-${f.id}`} onClick={() => openForm(f)}
              className="flex w-full flex-wrap items-center gap-3 rounded-xl border border-[#F1EEE7] px-4 py-2.5 text-left transition-colors hover:bg-[#FDFCF8]">
              <span className="min-w-0">
                <span className="block truncate text-sm font-semibold text-[#3E2723]">{f.template_name}</span>
                <span className="block text-[11px] text-[#7B6157]">{f.category} · {f.author || "Unknown author"}{(f.addendums || []).length > 0 ? ` · ${f.addendums.length} addendum${f.addendums.length === 1 ? "" : "s"}` : ""}</span>
              </span>
              <span className="ml-auto flex items-center gap-2">
                <span className="text-[11px] tabular-nums text-[#84675B]">{f.date ? dayjs(f.date).format("MMM D, YYYY") : ""}</span>
                {f.signed
                  ? <span className="rounded-full bg-[#E8F5E9] px-2 py-0.5 text-[10px] font-bold text-[#2E7D32]">SIGNED</span>
                  : <span className="rounded-full bg-[#FFF8E1] px-2 py-0.5 text-[10px] font-bold text-[#876600]">UNSIGNED</span>}
              </span>
            </button>
          ))}
        </div>
      )}
    </Card>
  );
}
